import { Box, useMediaQuery } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { NonCommerceInfoContext } from '@repo/contexts';
import DesktopNav from './DesktopNav';
import MobileNav from '../../molecules/MobileNav';

function Header({
  menuItems,
  notificationBanner,
  allCollections,
  carouselHeight,
}) {
  const [isPrint] = useMediaQuery('print');

  const { isNonCommerce } = useContext(NonCommerceInfoContext);

  const builtOutMenuItems = menuItems
    .map(mi => {
      let childCollections = [];
      if (mi.menuType === 'collection' && !mi?.collection?.store) {
        return null;
      }
      if (mi.menuType === 'collection') {
        // do something
        // find all the collections that start with the same title
        const itemCollections = allCollections
          .filter(c => c.language === mi.collection.language)
          .filter(c => c.store.title.startsWith(mi.collection.store.title));

        childCollections = itemCollections
          .filter(cc => cc.language === mi.collection.language)
          .filter(c => c.store.title.split('/').length === 2)
          .map(c => ({
            ...c,
            childCollections: itemCollections
              .filter(ic => ic.language === mi.collection.language)
              .filter(
                ic =>
                  ic.store.title !== c.store.title &&
                  ic.store.title.startsWith(c.store.title)
              ),
          }));
      }
      return {
        ...mi,
        childCollections,
      };
    })
    .filter(Boolean);

  if (isPrint) return null;

  const bannerShowing = !isNonCommerce && notificationBanner?.length > 0;

  return (
    <Box>
      <MobileNav
        menuItems={builtOutMenuItems}
        notificationBanner={notificationBanner}
        bannerShowing={bannerShowing}
        carouselHeight={carouselHeight}
      />
      <DesktopNav
        menuItems={builtOutMenuItems}
        notificationBanner={notificationBanner}
        bannerShowing={bannerShowing}
        carouselHeight={carouselHeight}
      />
    </Box>
  );
}

Header.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string,
      _type: PropTypes.string,
      columns: PropTypes.number,
      menuType: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
  notificationBanner: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  allCollections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  carouselHeight: PropTypes.number.isRequired,
};

export default Header;
